import * as React from 'react';
import { User } from '../../../../types/User';
import Dialog from '@material-ui/core/Dialog/Dialog';
import { useMediaQuery } from 'react-responsive';
import { MOBILE_MAX_WIDTH } from '../../../../utils';
import List from '@material-ui/core/List/List';
import ListItem from '@material-ui/core/ListItem/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar/Avatar';
import ListItemText from '@material-ui/core/ListItemText/ListItemText';

interface Props {
	users: User[];
	onClose: () => void;
}

const PopupUserList: React.FC<Props> = props => {
	const isMobile = useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });

	return <Dialog open={true} onClose={props.onClose}>
		<List>
			{props.users.map(user => {
				return <ListItem onClick={() => window.location.href = `/profile/#/${user.id}`}>
					<ListItemAvatar>
						<Avatar src={user.imageURL}/>
					</ListItemAvatar>
						
					<ListItemText primary={user.name}/>
				</ListItem>
			})}
		</List>
	</Dialog>
};

export default PopupUserList;
